import { useAppActions } from 'actions/app-actions';
import { AppErrorStatusCode } from 'common/constants';
import { AppStateController } from 'common/controller/AppStateController';
import UILogger from 'common/utils/logger';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { store } from 'setup/store';

const AppErrorHandler = () => {
  const navigate = useNavigate();
  const { doPostLogoutCleanup, setAppConnected } = useAppActions();
  const addAppErrorListener = (statusCode: AppErrorStatusCode) => {
    UILogger.error('appInit:addAppErrorListener::>>>>', statusCode);
    if (statusCode === AppErrorStatusCode.UNAUTHORIZED) {
      UILogger.error(
        'Unauthorized error detected. navigating to login screen. statusCode',
        statusCode,
        'loggedIn',
        store.getState().appReducer.isUserLoggedIn,
      );
      if (store.getState().appReducer.isUserLoggedIn) {
        doPostLogoutCleanup();
        navigate('/login');
      }
    } else if (statusCode == AppErrorStatusCode.ERR_NETWORK) {
      UILogger.error('Network error::>>>>');
      setAppConnected(false);
    } else if (statusCode == AppErrorStatusCode.NONE) {
      UILogger.error('Network error gone::>>>>');
      setAppConnected(true);
    }
  };
  useEffect(() => {
    AppStateController.getInstance().subscribeAppError('appInit', addAppErrorListener);
  }, []);
  return null;
};

export default AppErrorHandler;
